import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { SheetActionControlsBase } from 'src/app/services/sheets-renderer.service';
import { Row, Slot } from 'src/app/types/aggregate-graph.types';
import { NoteAction } from 'src/app/types/sheet-action-aggregate-graph.types';
import { ActionFormComponent } from '../../action-form/action-form.component';
import { CommonActionControlsComponent } from '../../common-action-controls/common-action-controls.component';

@Component({
    selector: 'app-note-action-controls',
    templateUrl: './note-action-controls.component.html',
    styleUrls: ['../../../common.scss', './note-action-controls.component.scss'],
    imports: [CommonActionControlsComponent, ActionFormComponent],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class NoteActionControlsComponent implements SheetActionControlsBase {

	slot!: Slot | null;
	action!: NoteAction;

	@Input('slot') set updateSlot(slot: Slot | null) {
		this.slot = slot;
		this.action = slot?.action as NoteAction;
	}

	@Input() form!: FormGroup;
	@Input() item!: Row | null;
	
	constructor() {
	}
}